const closeBtn = document.querySelector('.alert-close');

if (closeBtn) {
  closeBtn.addEventListener('click', () => {
    const alert = closeBtn.closest('.alert-component');
    if (alert) {
      alert.classList.add('fade-out');
      alert.addEventListener(
        'transitionend',
        () => {
          alert.remove();
        },
        { once: true }
      );
    }
  });
}